import { defineMessages } from "react-intl";

const messages = defineMessages({
  system: {
    id: "AuditLog.AuditLogList.system",
    defaultMessage: "System",
  },
  appointmentMarkedAsNoShow: {
    id: "AuditLog.AuditLogList.appointmentMarkedAsNoShow",
    defaultMessage: "Marked appointment as “no show”",
  },
  appointmentCanceled: {
    id: "AuditLog.AuditLogList.appointmentCanceled",
    defaultMessage: "Canceled appointment",
  },
  appointmentRescheduled: {
    id: "AuditLog.AuditLogList.appointmentRescheduled",
    defaultMessage: "Rescheduled appointment",
  },
  loggedInPatient: {
    id: "AuditLog.AuditLogList.loggedInPatient",
    defaultMessage: "Logged patient in manually",
  },
  checkedInPatient: {
    id: "AuditLog.AuditLogList.checkedInPatient",
    defaultMessage: "Checked patient in",
  },
  appointmentMarkedAsPriority: {
    id: "AuditLog.AuditLogList.appointmentMarkedAsPriority",
    defaultMessage: "Marked appointment as “priority”",
  },
  confirmedIncompleteAppointment: {
    id: "AuditLog.AuditLogList.confirmedIncompleteAppointment",
    defaultMessage: "Confirmed incomplete appointment",
  },
  addedFilesToAppointment: {
    id: "AuditLog.AuditLogList.addedFilesToAppointment",
    defaultMessage: "Added file to appointment",
  },
  addedPayment: {
    id: "AuditLog.AuditLogList.addedPayment",
    defaultMessage: "Added a payment",
  },
  reportsSentToPatient: {
    id: "AuditLog.AuditLogList.reportsSentToPatient",
    defaultMessage: "Report sent to patient",
  },
  receiptResentManually: {
    id: "AuditLog.AuditLogList.receiptResentManually",
    defaultMessage: "Sent receipt to customer",
  },
  reportMarkedAsUnexpectedFindings: {
    id: "AuditLog.AuditLogList.reportMarkedAsUnexpectedFindings",
    defaultMessage: "Marked report as “unexpected findings”",
  },
  reportMarkedAsUnexpectedFindingsConfirmed: {
    id: "AuditLog.AuditLogList.reportMarkedAsUnexpectedFindingsConfirmed",
    defaultMessage: "Marked report as “unexpected findings receipt confirmed”",
  },
  offeringChanged: {
    id: "AuditLog.AuditLogList.offeringChanged",
    defaultMessage: "Changed appointment offering",
  },
  studyMarkedAsAdditionalViewRequired: {
    id: "AuditLog.AuditLogList.studyMarkedAsAdditionalViewRequired",
    defaultMessage: "Study marked as requiring additional views",
  },
  refundAdded: {
    id: "AuditLog.AuditLogList.refundAdded",
    defaultMessage: "Added a refund",
  },
  appointmentPriceChanged: {
    id: "AuditLog.AuditLogList.appointmentPriceChanged",
    defaultMessage: "Changed appointment price",
  },
  // Merge audit — Account Merge AC1/AC2 exact wording
  mergedIntoThisCustomer: {
    id: "AuditLog.AuditLogList.mergedIntoThisCustomer",
    defaultMessage:
      "Merged {count, plural, one {# customer record} other {# customer records}} into this customer",
  },
  mergedIntoThisCustomerWithChanges: {
    id: "AuditLog.AuditLogList.mergedIntoThisCustomerWithChanges",
    defaultMessage:
      "Merged {count, plural, one {# customer record} other {# customer records}} into this customer and changed the following fields:",
  },
  mergedIntoOtherCustomer: {
    id: "AuditLog.AuditLogList.mergedIntoOtherCustomer",
    defaultMessage: "Merged into customer {id}",
  },
  // Patient Audit AC1 — same pattern, "patient" instead of "customer". No
  // AC text specifies the merged_from row's wording (AC1 only covers the
  // selected Patient); mirrors mergedIntoOtherCustomer for consistency.
  mergedIntoThisPatient: {
    id: "AuditLog.AuditLogList.mergedIntoThisPatient",
    defaultMessage:
      "Merged {count, plural, one {# patient record} other {# patient records}} into this patient",
  },
  mergedIntoThisPatientWithChanges: {
    id: "AuditLog.AuditLogList.mergedIntoThisPatientWithChanges",
    defaultMessage:
      "Merged {count, plural, one {# patient record} other {# patient records}} into this patient and changed the following fields:",
  },
  mergedIntoOtherPatient: {
    id: "AuditLog.AuditLogList.mergedIntoOtherPatient",
    defaultMessage: "Merged into patient {id}",
  },
});

export default messages;
